import style from './CompanyTitle.module.css';
import { useState, useEffect } from 'react';
import translation from '../../../../helpers/translation/index';
import { Helmet } from 'react-helmet';

const FONT_URL = '/fonts/MyFont.woff2';

const CompanyTitle = () => {
  const [activeLang, setActiveLang] = useState('en');
  const activeTranslate = translation[activeLang];

  useEffect(() => {
    const structuredData = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'Artemida Studio',
      url: 'https://artemidastudio.com',
      description: 'We create custom websites of any complexity',
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+48500815139',
        contactType: 'Customer Service',
      },
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.innerHTML = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, [activeTranslate]);

  return (
    <>
      <Helmet>
        {/* ✅ Попереднє завантаження шрифту */}
        <link
          rel="preload"
          href={FONT_URL}
          as="font"
          type="font/woff2"
          crossorigin="anonymous"
        />
        {/* ✅ Підключення стилів через link */}
        <link rel="stylesheet" href="/styles/index.css" />
        <style>
          {`
            h1, h2 {
              font-family: 'MyFont', sans-serif;
              font-display: swap;
            }
          `}
        </style>
      </Helmet>

      <div className={style.companyContainer}>
        <h1 aria-label="Company name">Artemida Studio</h1>
        <h2 aria-label="Company description">
          {activeTranslate.heroSection.companyDescription}
        </h2>
        <a href="#contact" aria-label="Contact Artemida Studio">
          <button className={style.contactUs} aria-label="Contact us button">
            {activeTranslate.heroSection.contactUs}
          </button>
        </a>
      </div>
    </>
  );
};

export default CompanyTitle;
